import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'

interface MultiTextProps {
  question: any
  control: any
  getValues: any
  indexByPage: number
}

const MultiText: React.FC<MultiTextProps> = (props) => {
  const { t } = useTranslation()
  const { question, control, getValues, indexByPage } = props

  const errorMessage = t('Please enter at least {{min}} values or no more then {{max}}', { min: question?.requiredMin, max: question?.requiredMax })

  return <>
    <Form.Field label={`${question?.question} (min: ${question?.requiredMin} - max: ${question?.requiredMax})`} required={Boolean(question?.required)} />
    {Array.from({ length: question?.value }, (_, index) => index).map((anwser, index) => {
      return <FormFields.TextArea
        control={control}
        key={anwser}
        rules={{
          validate: (value) => {
            const answers = getValues(`questions[${indexByPage}].answers`) || []
            const answersFilled = answers.filter(answer => !!answer?.customText)
            if (value && answersFilled.length < question?.requiredMax) {
              return true
            }
            if (question?.required) {
              return (answersFilled.length >= question?.requiredMin && answersFilled.length <= question?.requiredMax) || errorMessage
            }
            return false
          },
          maxLength: {
            value: 2000,
            message: t('Max. number of characters is 2000')
          }
        }}
        name={`questions[${indexByPage}].answers[${index}].customText`}
        placeholder={question?.placeholder}
      />
    })}
  </>
}
export default MultiText